import React from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/ProjectsAndVessels/ShipOwner/add'
import constant from '../../../constant'
import { toast } from 'react-toastify'
import { v3_add_ship_owner } from '../../../actions/v3/projectAndVessel'
const Add = (props) => {

    const onSubmit = (model) => {
        v3_add_ship_owner(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                props.history.push(constant.Authedcomponent.listShipOwnerMasterData.url)
            }
            else {
                toast.error(res.error)

            }
        })
    }
    return (
        <React.Fragment>
            <Layout
                title={'Owner'}
            >
                <Form
                    title={'Add Owner'}
                    onSubmit={onSubmit}
                    buttonName={'Create Owner'}
                />
            </Layout>
        </React.Fragment>
    )
}

export default Add